<ng-container  *transloco="let t; read: 'support-page'">
  <div class="iframe-container" *appIfRole="'support'">
    <iframe src="https://share.hsforms.com/1wr8kW90fTIComjqf1qxQhw4cjdz" width="100%" height="100%"></iframe>
  </div>

  <a href="https://helplinesoftware.zendesk.com/hc/en-us" rel="noreferrer noopener" target="_blank">{{
  t('comingSoon')
  }}</a>

</ng-container>